"use strict";

var React           = require("react");
var Navbar          = require("react-bootstrap").Navbar;
var Nav             = require("react-bootstrap").Nav;
var Link            = require("react-router").Link;
var headerLogo      = require("../../../images/header_logo.jpg");

var NavbarFrontPage = React.createClass({
    render: function () {
        return (
            <Navbar className="frontpage-navbar" brand={<Link to="/frontpage"><img src={headerLogo}></img></Link>} fixedTop toggleNavKey={0}>
                <Nav right eventKey={0}>
                    <li><Link to="/frontpage">Þjónustan</Link></li>
                    <li><Link to="/home">Bankinn</Link></li>
                    <li className="frontpage-login"><Link to="/login">Innskrá</Link></li>
                </Nav>
            </Navbar>
        );
    }
});

module.exports = NavbarFrontPage;



// WEBPACK FOOTER //
// ./app/scripts/ui/Frontpage/FrontpageNavbar.react.js